// reason: these are the color tokens so they are hardcoded
// eslint-disable @dhl/mui/no-hardcoded-colors
export const additional = {
  brightYellow: '#FFD700',
  radiantGold: '#AC8100',
  hotPink: '#E91E63',
  dangerRed: '#FF000D',
  turquoise: '#00B2A9',
  limeGreen: '#A8E600',
  vibrandBlue: '#005BBB',
  mysteriousPurple: '#6A0DAD',
  warmGreen: '#C4D19A',
  coolGreen: '#A3D0B8',
  lightBlue: '#B2DEF3',
  lightViolet: '#C5D3F0',
  darkViolet: '#B7BBCE',
} satisfies Record<string, string>
